import React from "react";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => (
  <section id="about" className="bg-[#f4f2fb] py-24">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <p className="reveal text-xs font-semibold tracking-[0.22em] uppercase text-[#7c3aed] mb-4">
        Real People, Real Help
      </p>
      <div className="reveal flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
        <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#1e183a] leading-tight">
          Trusted across the UK.
        </h2>
        <div className="flex items-center gap-2">
          <div className="flex gap-0.5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 text-[#7c3aed] fill-[#7c3aed]" />
            ))}
          </div>
          <span className="font-semibold text-[#1e183a]">Rated Excellent</span>
        </div>
      </div>

      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {testimonials.map((t) => (
          <div
            key={t.name}
            className="reveal rounded-3xl bg-white border border-[#1e183a]/8 p-8 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-30px_rgba(19,26,51,0.4)]"
          >
            <Quote className="w-9 h-9 text-[#7c3aed]/25" />
            <div className="flex gap-0.5 mt-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 text-[#7c3aed] fill-[#7c3aed]" />
              ))}
            </div>
            <p className="mt-4 text-[#1e183a]/80 leading-relaxed flex-1">{t.quote}</p>
            <div className="mt-6 pt-5 border-t border-[#1e183a]/8">
              <p className="font-semibold text-[#1e183a]">{t.name}</p>
              <p className="text-sm text-[#1e183a]/50">{t.meta}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
